"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var downshift_1 = __importDefault(require("downshift"));

var react_1 = __importStar(require("react"));

var theme_1 = require("../../../styles/theme");

var Chevron_1 = __importDefault(require("../../../icons/Chevron"));

var Caption_1 = __importDefault(require("../../base/Caption"));

var Subtitle_1 = __importDefault(require("../../base/Subtitle"));

var Container = styled_1["default"]('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: ", "px;\n"], ["\n  margin-bottom: ", "px;\n"])), theme_1.theme.spacing.small * 3);
var HelperText = styled_1["default"](Caption_1["default"])(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 5px;\n  color: ", ";\n  text-indent: 3px;\n"], ["\n  margin-top: 5px;\n  color: ", ";\n  text-indent: 3px;\n"])), theme_1.theme.inputHelperTextColor);
var Label = styled_1["default"](Subtitle_1["default"])(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  color: ", ";\n  flex-direction: column;\n  margin-bottom: 4px;\n  max-width: ", ";\n  min-width: ", "px;\n  position: relative;\n  .icon {\n    margin-left: -", "px;\n    top: ", "px;\n  }\n  &:hover {\n    color: ", ";\n    input:not(:focus) {\n      border-color: ", ";\n    }\n  }\n"], ["\n  display: flex;\n  color: ", ";\n  flex-direction: column;\n  margin-bottom: 4px;\n  max-width: ", ";\n  min-width: ", "px;\n  position: relative;\n  .icon {\n    margin-left: -", "px;\n    top: ", "px;\n  }\n  &:hover {\n    color: ", ";\n    input:not(:focus) {\n      border-color: ", ";\n    }\n  }\n"])), theme_1.theme.labelColor, function (props) {
  return props["long"] ? '100%' : theme_1.theme.spacing.standard * 15 + "px";
}, theme_1.theme.spacing.standard * 8, theme_1.theme.spacing.small * 4, theme_1.theme.spacing.standard * 1.5, theme_1.theme.labelColorHover, theme_1.theme.inputBorderColorHover);
var ToggleContainer = styled_1["default"].div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  border: 1px solid ", ";\n  &:hover {\n    border-color: ", ";\n  }\n  border-radius: 5px;\n  text-align: left;\n  padding-left: 0.5em;\n  font-size: 1em;\n  background-color: ", ";\n"], ["\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  border: 1px solid ", ";\n  &:hover {\n    border-color: ", ";\n  }\n  border-radius: 5px;\n  text-align: left;\n  padding-left: 0.5em;\n  font-size: 1em;\n  background-color: ", ";\n"])), function (props) {
  return props.isOpen ? theme_1.theme.inputBorderColorFocus : theme_1.theme.inputBorderColor;
}, function (props) {
  return props.isOpen ? theme_1.theme.inputBorderColorFocus : theme_1.theme.inputBorderColorHover;
}, function (props) {
  return props.disabled ? theme_1.theme.colors.Gray6 : '#FFF';
});
var ToggleButton = styled_1["default"]('button')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  flex-basis: 0;\n  display: inline-block;\n  margin: 0.5em 0 0 0;\n  height: 1.5em;\n  border: none;\n  font: inherit;\n  color: ", ";\n  background-color: transparent;\n  cursor: pointer;\n  white-space: nowrap;\n"], ["\n  flex-basis: 0;\n  display: inline-block;\n  margin: 0.5em 0 0 0;\n  height: 1.5em;\n  border: none;\n  font: inherit;\n  color: ", ";\n  background-color: transparent;\n  cursor: pointer;\n  white-space: nowrap;\n"])), theme_1.theme.inputColor);
var ToggleArrow = styled_1["default"](Chevron_1["default"])(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  flex-basis: auto;\n  margin-right: 0.3em;\n  background-color: transparent;\n  height: 2.5em;\n  width: 2em;\n"], ["\n  flex-basis: auto;\n  margin-right: 0.3em;\n  background-color: transparent;\n  height: 2.5em;\n  width: 2em;\n"])));
var Menu = styled_1["default"].div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  border-top: 0;\n  border-radius: 0 0 5px 5px;\n  display: inline-block;\n  width: auto;\n  max-height: 240px;\n  overflow-y: scroll;\n  position: absolute;\n  z-index: 1;\n  background-color: #fff;\n"], ["\n  border: 1px solid ", ";\n  border-top: 0;\n  border-radius: 0 0 5px 5px;\n  display: inline-block;\n  width: auto;\n  max-height: 240px;\n  overflow-y: scroll;\n  position: absolute;\n  z-index: 1;\n  background-color: #fff;\n"])), function (props) {
  return props.isOpen ? theme_1.theme.inputBorderColorHover : theme_1.theme.colors.Gray2;
});
var MenuSectionTitle = styled_1["default"]('label')(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: block;\n  margin: 1.5em 0 0.5em 0;\n  color: ", ";\n  font-weight: bold;\n  font-size: 0.8em;\n  text-transform: uppercase;\n  padding: 0 1em;\n  white-space: nowrap;\n"], ["\n  display: block;\n  margin: 1.5em 0 0.5em 0;\n  color: ", ";\n  font-weight: bold;\n  font-size: 0.8em;\n  text-transform: uppercase;\n  padding: 0 1em;\n  white-space: nowrap;\n"])), theme_1.theme.colors.Gray2);
var Option = styled_1["default"].label(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  line-height: 2em;\n  cursor: pointer;\n  display: block;\n  padding: 0 1em;\n  white-space: nowrap;\n"], ["\n  background-color: ", ";\n  color: ", ";\n  line-height: 2em;\n  cursor: pointer;\n  display: block;\n  padding: 0 1em;\n  white-space: nowrap;\n"])), function (props) {
  return props.isHighlighted ? theme_1.theme.colors.Green100 : 'transparent';
}, function (props) {
  return props.isHighlighted ? '#FFF' : 'inherit';
});

var Dropdown =
/** @class */
function (_super) {
  __extends(Dropdown, _super);

  function Dropdown(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      initialWidth: 'auto',
      optionWidth: 'auto',
      selectedOption: undefined,
      toggleContainerWidth: 'auto'
    };
    _this.buttonRef = react_1["default"].createRef();
    _this.menuRef = react_1["default"].createRef();
    _this.toggleRef = react_1["default"].createRef(); // Load an option by value?
    // NOTE: This could cause a bug if there are multiple options
    // with the same value in distinct sections

    var selectedOption;

    if (props.selectedValue) {
      for (var _i = 0, _a = props.sections; _i < _a.length; _i++) {
        var section = _a[_i];

        for (var _b = 0, _c = section.options; _b < _c.length; _b++) {
          var option = _c[_b];

          if (option.value === props.selectedValue) {
            selectedOption = option;
            break;
          }
        }
      }
    }

    _this.state = {
      selectedOption: selectedOption,
      initialWidth: 'auto',
      optionWidth: 'auto',
      toggleContainerWidth: 'auto'
    };
    _this.onChange = _this.onChange.bind(_this);
    _this.onStateChange = _this.onStateChange.bind(_this);
    return _this;
  }

  Dropdown.prototype.onChange = function (option, stateAndHelpers) {
    this.setState({
      selectedOption: option
    }); // If there's an onChange handler, call it
    // with the selected option

    if (typeof this.props.onChange === 'function') {
      // This object contains section and option indexes,
      // unlike the `option` parameter above
      this.props.onChange(stateAndHelpers.selectedItem);
    }
  };

  Dropdown.prototype.onStateChange = function (changes, stateAndHelpers) {
    if (!changes.hasOwnProperty('isOpen')) {
      return; // Only concerned with open / close for now
    }

    var isOpen = changes.isOpen;
    var selectedItem = stateAndHelpers.selectedItem;
    var newState = {}; // If closing without a selection, restore the initial state

    if (!isOpen && !selectedItem && this.state.initialWidth) {
      this.setState({
        toggleContainerWidth: this.state.initialWidth
      });
      return;
    } // Set toggle container width based on the widest option
    //  (or the default, whichever is greater)


    var toggleContainer = this.toggleRef.current.getBoundingClientRect();
    var maxOptionWidth = toggleContainer.width;
    var items = this.menuRef.current.getElementsByClassName('dropdown-item');

    for (var _i = 0, _a = items; _i < _a.length; _i++) {
      var el = _a[_i];
      var width = el.getBoundingClientRect().width;
      maxOptionWidth = Math.max(maxOptionWidth, width);
    } // Either set the toggle width or the option width


    var scrollbarWidth = 18;

    if (maxOptionWidth > toggleContainer.width) {
      newState.toggleContainerWidth = maxOptionWidth + scrollbarWidth + "px";
    } else {
      newState.optionWidth = toggleContainer.width - scrollbarWidth + "px";
    } // If it's not set, save the initial width so we can restore it


    newState.initialWidth = newState.initialWidth || toggleContainer.width + "px";
    this.setState(newState);
  };
  /* tslint:disable */


  Dropdown.prototype.render = function () {
    var _this = this;

    var placeholder = this.props.placeholder;
    var selectedOption = this.state.selectedOption; // NOTE: this uses some inline styles since Downshift requires
    // additional configuration to support non-native elements
    // (i.e. divs vs. styled components)

    return react_1["default"].createElement(Container, {
      id: this.props.id
    }, this.props.label && react_1["default"].createElement(Label, {
      small: true
    }, this.props.label), react_1["default"].createElement(downshift_1["default"], {
      onChange: this.onChange,
      onStateChange: this.onStateChange,
      initialSelectedItem: this.state.selectedOption,
      itemToString: function itemToString(item) {
        return item ? [item.name, item.value].join('_') : '';
      }
    }, function (_a) {
      var isOpen = _a.isOpen,
          getItemProps = _a.getItemProps,
          getLabelProps = _a.getLabelProps,
          getMenuProps = _a.getMenuProps,
          getToggleButtonProps = _a.getToggleButtonProps,
          highlightedIndex = _a.highlightedIndex,
          dsSelectedItem = _a.selectedItem;
      return react_1["default"].createElement("div", null, react_1["default"].createElement("div", {
        style: {
          cursor: 'pointer',
          display: 'inline-block'
        },
        ref: _this.toggleRef
      }, react_1["default"].createElement(ToggleContainer, __assign({}, getToggleButtonProps({
        style: {
          width: _this.state.toggleContainerWidth
        }
      }), {
        isOpen: isOpen
      }), react_1["default"].createElement(ToggleButton, {
        ref: _this.buttonRef
      }, selectedOption ? selectedOption.name : placeholder), react_1["default"].createElement(ToggleArrow, {
        fill: theme_1.theme.colors.Clay80,
        rotation: isOpen ? 270 : 90
      }))), react_1["default"].createElement("div", {
        ref: _this.menuRef,
        style: {
          clear: 'both',
          position: 'relative'
        }
      }, !isOpen ? null : react_1["default"].createElement(Menu, __assign({}, getMenuProps(), {
        isOpen: isOpen
      }), _this.props.sections.reduce(function (result, section, sectionIndex) {
        var title = section.title,
            options = section.options;
        result.sections.push(react_1["default"].createElement("div", {
          key: "section-" + sectionIndex
        }, title ? react_1["default"].createElement(MenuSectionTitle, null, title) : null, options.map(function (option, optionIndex) {
          var index = result.itemIndex++;
          return react_1["default"].createElement(Option, __assign({
            key: "option-" + optionIndex,
            className: 'dropdown-item',
            isHighlighted: highlightedIndex === index,
            isSelected: dsSelectedItem === option
          }, getItemProps({
            key: "section-" + sectionIndex + "-option-" + optionIndex,
            item: __assign(__assign({}, option), {
              section: sectionIndex,
              option: index
            }),
            index: index,
            style: {
              width: _this.state.optionWidth
            }
          }), getLabelProps()), option.name);
        })));
        return result;
      }, {
        sections: [],
        itemIndex: 0
      }).sections)));
    }), react_1["default"].createElement(HelperText, null, this.props.helperText));
    /* tslint:enable */
  };

  return Dropdown;
}(react_1.Component);

exports["default"] = Dropdown;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;